// TypeScript interfaces for Private Text Generator
// Based on workbook_page_content table structure for standalone private pages

export interface PrivatePageItem {
  id: string;
  user_id: string;
  workbook_id: string | null; // Always null for private pages
  title: string;
  content: string;
  type: string | null;
  writing_style: string | null;
  initial_request: string | null;
  openai_thread_id: string | null;
  created_at: string;
  updated_at: string;
}

export interface PrivatePageCreationParams {
  title: string;
  content?: string;
  type?: string;
  writing_style?: string;
  initial_request?: string;
}

export interface PrivatePageFilter {
  searchQuery?: string;
  pageType?: string;
  writingStyle?: string;
  limit?: number;
  offset?: number;
}

// Transform interface to match PageGrid component expectations
export interface PageGridItem {
  id: string;
  title: string;
  type: string;
  updated_at: string;
  content?: string;
}

// Transform function to convert PrivatePageItem to PageGridItem
export const transformToPageGridItem = (page: PrivatePageItem): PageGridItem => {
  return {
    id: page.id,
    title: page.title,
    type: page.type || 'Standard Page',
    updated_at: page.updated_at,
    content: page.content,
  };
}; 